import React from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import AddCauseModal from "./AddCauseModal";
import CauseCard from "./CauseCard";
import "./index.css";

class Cause extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      brand: "",
      role: "",
      loading: true,
      causes: [],
    };
  }

  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      console.log("role", role);
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (!brand_data) return;
        this.setState({
          logo: brand_data.logo,
          icon: brand_data.icon,
          territory: brand_data.territory,
          brand_name: brand_data.name,
          brand_url: brand_data.url,
          hex: brand_data.hex,
          is_property_brand: brand_data.is_property_brand
            ? brand_data.is_property_brand
            : false,
        });
        Firebase.getAllCauses(brand_data.name, (causes) => {
          console.log("causes", causes);
          this.setState({ causes: causes, loading: false });
        });
      });
    }
  }

  onItemClicked = (selectedTokenEarning) => {
    this.setState({
      selectedTokenEarning,
      icon: selectedTokenEarning.icon,
    });
  };
  renderContent = () => {
    const { causes } = this.state;
    return (
      <div className="cause-content">
        <div className="cause-items">
          {causes.map((item, index) => (
            <CauseCard item={item} />
          ))}

          <div
            className="btn-secondary cause-item add-cause-btn"
            data-toggle="modal"
            data-target="#add_cause_modal"
            onClick={this.addClicked}
          >
            <p style={{ fontSize: "65px", lineHeight: "65px" }}>+</p>
            <p className="cause-item-text">Add a new cause</p>
          </div>
        </div>
      </div>
    );
  };

  createCause = async (payload) => {
    console.log("payload", payload);
    const {
      img_content,
      title,
      is_price_fixed,
      address,
      is_token_shopping,
      price,
      token,
    } = payload;
    let { brand_name, causes } = this.state;
    let folder = "causes/" + brand_name;
    this.setState({ loading: true });
    let image_url = await Firebase.uploadImage(img_content, title, folder);
    let cause = {
      title,
      address,
      image_url,
      is_price_fixed,
      price: price,
      is_token_shopping,
      token,
    };
    Firebase.addCause(cause, brand_name).then((res) => {
      causes.push(cause);
      this.setState({ loading: false, causes });
    });
  };
  render() {
    const {
      username,
      role,
      loading,
      logo,
      brand,
      brand_name,
      is_property_brand,
      territory,
    } = this.state;

    return (
      <div id="page-container" className="cause-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          {loading && (
            <div className="loading">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          )}
          {!loading && this.renderContent()}
          <AddCauseModal createCause={this.createCause} territory={territory} />
        </main>
      </div>
    );
  }
}

export default Cause;



// WEBPACK FOOTER //
// ./src/screens/Cause/index.js